import { Button, ButtonProps } from 'bold-ui'
import React from 'react'
import { useHistory } from 'react-router'
import { LinkProps } from 'react-router-dom'

export interface NavigationButtonProps extends ButtonProps, Pick<LinkProps, 'to'> {}

export function NavigationButton(props: Readonly<NavigationButtonProps>) {
  const { to, onClick, ...rest } = props
  const history = useHistory()

  const handleOnClick = (event) => {
    onClick?.(event)
    history.push(to.valueOf())
  }

  return <Button {...rest} onClick={handleOnClick} />
}
